import * as React from 'react'
import { Text } from '$views/components'
import { draft } from '$utils/services/formDraftService'
import { broadcastFormDraftName, broadcastFormSteps } from '$views/RecommendationsForms/BroadcastForm/BroadcastForm'
import { Field } from 'formik'
import { Textarea } from '$views/components/Forms/Textarea'

export const CareInformation: React.FC<Props> = () => {
  const onBlurTextArea = event => {
    draft.set(broadcastFormDraftName, {
      [event.currentTarget.name]: event.currentTarget.value,
    })
  }

  return (
    <>
      <Text marginTop="mini" marginBottom="mini">
        Detalles sobre qué buscas.
      </Text>
      <Field
        name={broadcastFormSteps.serviceInformationStep.careInformation}
        component={Textarea}
        placeholder={'Detalles sobre vuestra situación. Necesidades y requisitos.'}
        onBlur={onBlurTextArea}
        maxLengthLabel={400}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/components/CareInformation/CareInformation.tsx